import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';
import { Alert } from 'selenium-webdriver';
import { isNumber } from 'util';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss'],
})
export class QuizComponent implements OnInit {

  @Input() url: any;
  @Input() id: any;
  @Input() edit: number;

  @Output() eventchild = new EventEmitter<string>();


  tabQuest: any;
  nbquest: number;
  posiquest: number = -1;
  tabPosQuest = [];
  tabComponents = [];
  visibtvalider: boolean = true;
  visinumquest : boolean = true;
  btvalider: string = "Démarrer le questionnaire";
  nbBonneReponse: number = 0;

  //http://web.cs.iastate.edu/~honavar/JavaNotes/Notes/chap12/chap12quiz.html

  constructor(public gfichier: GfichierService) { }

  ngOnInit() {
   
   }

  ngOnChanges() {

    //alert("nbnbn"); 

  
  if(isNumber(this.url)) {
    //alert("klkl");
    this.eventchild.emit("hidebtvalider");
  
    this.gfichier.loadFichier(String(this.url)).then(
      successData => {

        //alert(successData);

        this.tabQuest = JSON.parse(String(successData));

        this.eventchild.emit("hidebtprecedent");

       //alert(JSON.stringify(this.tabQuest[0][0]["visi"]));
        if(this.tabQuest[0][0]["visi"]== false ) this.eventchild.emit("showvisiquiz"); 


        this.nbquest = Object.keys(this.tabQuest).length;




          let tab1 = [];
          for(let i = 1 ; i<this.nbquest;i++) {
          //for (let i = 0; i < this.nbquest; i++) {
            tab1.push(i);
          }
  
          let hasard: number;
          this.tabPosQuest.push(0);
          for(let i = 0 ; i<this.nbquest-1;i++) {
          //for (let i = 0; i < this.nbquest; i++) {
            hasard = Math.floor(Math.random() * tab1.length);
            //hasard = i;
            this.tabPosQuest.push(tab1[hasard]);
            //this.tabnumquest.push(i);
  
            tab1.splice(hasard, 1);
          }
  
          //alert(this.tabPosQuest);
          
        this.changerquest();

      },
      rejectData => {
        console.log(rejectData);
      }
     );
    } else {
      this.eventchild.emit("hidevisiquiz");
    }

  }//fin onngchange

  changerquest() {

     if(this.edit > 0)
        this.gfichier.setQuiz(this.tabQuest,this.id);


    this.posiquest++;

    if (this.posiquest > 0) {

      this.btvalider = "Valider";
      this.visibtvalider = false;

    }
    //affiche le bouton suivant quand plus de questions
     

    if (this.posiquest >= this.nbquest) {
      
      this.eventchild.emit("showbtvalider");
      let afficher ="Vous avez obtenu " + this.nbBonneReponse + " / " + (this.nbquest-1);
      
      //sauvegarde total et nombre de question dans json
      this.tabQuest[0][0]["tot"] = this.nbBonneReponse;
      this.tabQuest[0][0]["nbq"] = this.nbquest-1;
      

      this.tabComponents.splice(0,this.tabComponents.length);
      this.tabComponents.push({
        key : "text",
        value : afficher
      })
      this.visinumquest = false;
      this.gfichier.seconnecter2();
    }
    else {
      this.tabComponents = this.getTabQuest();
    }
    // alert(this.tabComponents);
  }

  //retourne la page 
  getTabQuest() {

    //alert(this.posiquest);
    //alert(this.tabQuest[0]);
    let lgTab = Object.keys(this.tabQuest[this.posiquest]).length;
    //let lgTab = this.tabQuest[this.posiquest].length;

    let tabArray = [];
    //let tab1 : any; 
    //alert(JSON.stringify(tabPage));

    for (let i = 0; i < lgTab; i++) {
      for (let x in this.tabQuest[this.tabPosQuest[this.posiquest]][i]) {
        
        tabArray.push({
          id: i,
          key: x,
          value: this.tabQuest[this.tabPosQuest[this.posiquest]][i][x]
        });
      }
    }//fin for

    // alert(tabArray); 
    return tabArray;
    // alert(this.route.snapshot.paramMap.get("idp"));

  }

  valider() {

    //alert(JSON.stringify(this.tabComponents));
    let lgTab = this.tabComponents.length;

    for (let i = 0; i < lgTab; i++) {
      //alert(this.tabComponents[i].key);
      if (this.tabComponents[i].key == "radio" ) {

        if (this.tabComponents[i]["value"][0].res)
          this.nbBonneReponse++;

        //met à jour la cellule radio

        this.tabQuest[this.tabPosQuest[this.posiquest]][this.tabComponents[i].id]["radio"] = this.tabComponents[i]["value"];

        // alert(true);  
        // alert(JSON.stringify(this.tabQuest));

      }
      else if (this.tabComponents[i].key == "chekbox" ) {

         if (this.tabComponents[i]["value"][0].res)
            this.nbBonneReponse++;

      //met à jour la cellule radio

        this.tabQuest[this.tabPosQuest[this.posiquest]][this.tabComponents[i].id]["chekbox"] = this.tabComponents[i]["value"];

      // alert(true);  
      // alert(JSON.stringify(this.tabQuest));

    } 



    }//fin for

    this.changerquest();


  }//fin valider


  retourchild($event) {
    //alert($event);
    //"changerquestion"
    if ($event == "btvalider") this.visibtvalider = true;
    else if ($event == "btvaliderquiz") this.visibtvalider = true;
    else if ($event == "hidebtvaliderquiz") this.visibtvalider = false;
    else if ($event == "showbtvaliderquiz") this.visibtvalider = true;
    //chrono terminé
    else if ($event == "changerquestion") this.valider();
   
  }



}
